import { http } from 'services/http';
import type { CargoTripRes, TAddCargoToActiveTripReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { CARGO_ITEMS_MANY, CARGO_TRIPS_MANY, TRIP_GET_ONE } from '../query-keys.ts';

interface IAddCargoToActiveTripValue {
  tripId: number;
  data: TAddCargoToActiveTripReq;
  updatedCargoId?: number;
}

export const useAddCargoToActiveTrip = () => {
  return useMutationBase<CargoTripRes, unknown, IAddCargoToActiveTripValue>({
    mutationFn: async ({ tripId, data }) => {
      const res = await http.post<CargoTripRes>(`/v1/trips/${tripId}/cargo-trips/active`, data);
      return res.data;
    },
    invalidateCallback: (_, { tripId, updatedCargoId }) => {
      const keys = [
        [TRIP_GET_ONE, tripId],
        [CARGO_TRIPS_MANY, tripId],
      ];

      if (updatedCargoId) keys.push([CARGO_ITEMS_MANY, updatedCargoId]);

      return keys;
    },
  });
};
